export function AgentRanking() {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
      <h3 className="text-sm font-semibold text-slate-200 mb-1">Agent Quality Ranking</h3>
      <p className="text-xs text-slate-500 mb-6">Sorted by average quality score</p>
      <div className="flex flex-col items-center justify-center py-8 gap-3">
        <span className="text-4xl">🏆</span>
        <p className="text-slate-300 font-medium text-sm">Coming soon</p>
        <p className="text-slate-500 text-xs text-center max-w-xs">
          Agent rankings will be available when call scoring is enabled.
        </p>
      </div>
    </div>
  );
}
